import {GetStaticProps, InferGetStaticPropsType} from 'next';
import React from 'react';

import {useEnvironment} from '../../../features/common/EnvironmentProvider';
import {getCmsEntry} from '../../../features/strapi';
import {GeneralCalculator} from '../../../features/strapi/generated/components';
import {ApiCalculatorsFctCalculatorsFct, ApiFooterFooter} from '../../../features/strapi/generated/contentTypes';
import {ProcessedValues} from '../../../features/strapi/types';
import CalculatorWrapper from '../../../features/tool/components/calculators/CalculatorWrapper';
import FCTCalculator from '../../../features/tool/components/calculators/FCTCalculator';
import Footer from '../../../features/tool/components/Footer';
import {getToolLayout} from '../../../features/tool/components/Layout';
import Newsletter from '../../../features/tool/components/Newsletter';
import {CALCULATOR_PARAMS, CALCULATOR_PROCESS_DATA_MAP} from '../../../features/tool/util/calculators.util';
import {buildStaticPropsResponse} from '../../../features/tool/util/dataFetch';
import {NextPageWithLayout} from '../../_app';

type Props = {
  footer: ProcessedValues<ApiFooterFooter>;
  calculatorsFCT: ProcessedValues<ApiCalculatorsFctCalculatorsFct>;
};

const FCTCalculatorPage: NextPageWithLayout<InferGetStaticPropsType<typeof getStaticProps>> = ({
  footer,
  calculatorsFCT,
}) => {
  const environment = useEnvironment();

  return (
    <>
      <CalculatorWrapper calculator={calculatorsFCT.calculator as ProcessedValues<GeneralCalculator>}>
        <FCTCalculator />
      </CalculatorWrapper>
      {environment && <Newsletter data={environment.newsletter} />}
      <Footer data={footer} />
    </>
  );
};

export const getStaticProps: GetStaticProps<Props> = async () => {
  const {footer} = await getCmsEntry<ApiFooterFooter, 'footer'>({path: 'footer'});
  const {calculatorsFCT} = await getCmsEntry<ApiCalculatorsFctCalculatorsFct, 'calculatorsFCT'>({
    path: 'calculators-fct',
    rootKey: 'calculatorsFCT',
    params: CALCULATOR_PARAMS,
    processDataMap: CALCULATOR_PROCESS_DATA_MAP,
  });

  return buildStaticPropsResponse({
    footer,
    calculatorsFCT,
  });
};

export default FCTCalculatorPage;

FCTCalculatorPage.getLayout = getToolLayout;

FCTCalculatorPage.title = 'Calculators';
